export default __webpack_public_path__ + "907d7ae0d49f376aaac3504b20bc6bff.svg";